import { useSelector } from 'react-redux';
import { api } from './';

export type RootState = {
  [api.reducerPath]: ReturnType<typeof api.reducer>;
};

const QUERY_NAMES = new Set(['getPrayerHubs', 'getPrayerHub']);

export function useIsApiBusy() {
  return useSelector((state: RootState) =>
    Object.values(state[api.reducerPath].queries).some(
      (query) =>
        query?.status === 'pending' &&
        query.endpointName != null &&
        QUERY_NAMES.has(query.endpointName)
    )
  );
}
